import { ObserverModel as CoreObserverModel } from 'projects/core/src/lib/models/observer.model';
import { Deserializable } from 'projects/core/src/lib/models/deserializable';
import { AcStatusUserType, BusyType } from './acstatus/ac-status.type';

export class ObserverModel extends CoreObserverModel implements Deserializable {

  // client
  hashed_id: string;
  userStatus: AcStatusUserType = null;
  busy: BusyType | null = null;
  avatar: string | null;

  public setUserStatus(userStatus: AcStatusUserType): void {
    this.userStatus = userStatus;
    if (this.userStatus.timezone) {
      this.timezone = this.userStatus.timezone;
    }
    if (this.userStatus.timezone) {
      this.tz_offset = this.userStatus.tz_offset;
    }
    if (this.userStatus.avatar === 'DELETED') {
      this.avatar = null;
    } else if (this.userStatus.avatar) {
      this.avatar = this.userStatus.avatar;
    }
  }

  public isOnline(): boolean {
    return this.userStatus?.is_online === true;
  }

  public isBusy(): boolean {
    return this.busy !== null;
  }

}
